export const CONTINUE_PAGE_AFTER_AUTHORIZE = 'continue-page';
export const RESUME_SIGNUP_CODE = 'resume-signup-code';
export const EXTERNAL_PAYMENT = 'external-payment';
export const SESSION_LANGUAGE = 'session-language';
